import React from 'react'
import { Card, Tabs, Tab } from 'react-bootstrap'
import Transaction from './transaction'
import GenPayment from './genPayment'
import AffiliateStatement from './statement'
import TransferToggle from './transferToggle'

export default function Affiliate() {
  return (
    <Card body>
      <Tabs defaultActiveKey={1} variant="pills" id="affiliate-tab-example">
        <Tab eventKey={1} title="Transaction">
          <Transaction />
        </Tab>
        <Tab eventKey={2} title="Statement">
          <AffiliateStatement />
        </Tab>
        <Tab eventKey={3} title="Gen Payment">
          <GenPayment />
        </Tab>
        <Tab eventKey={4} title="Transfer Toggle">
          <TransferToggle />
        </Tab>
      </Tabs>
    </Card>
  )
}
